'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}else{return Array.from(arr)}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const zonedMoment=require('pulsar-utils/dist-es6/time/zonedMoment');
const moment=require('pulsar-utils/dist-es6/time/moment');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const CalendarDay=require('pulsar-utils/dist-es6/time/calendarDay');

const DayInMilliseconds=8.64e7;
const DefaultTransitionDuration=380;
const TotalMonthsToDisplayInGraph=5;

const StatisticsPanelHeaderHeight=35;
const StatisticsPanelHeaderBottomBorderThickness=2;
const StatisticsPanelBodyVerticalDividingBorderThickness=1;
const StatisticsPanelWrapperBorderThickness=1;
const MinimumStatisticsPanelDimensions={
height:137,
width:281};


const YEAR_MONTH_FORMAT='YYYY-MM';let

StatisticsPanelHelpers=function(){function StatisticsPanelHelpers(){_classCallCheck(this,StatisticsPanelHelpers)}StatisticsPanelHelpers.
filterSortedIncidentsToIntervalPlusOneBefore=function filterSortedIncidentsToIntervalPlusOneBefore(incidents,interval){
const filteredIncidents=[];
let finalIncidentBeforeInterval=null;

const intervalStartTime=interval.start.getTime();
const intervalEndTime=interval.end.getTime();

for(const incident of incidents){
const incidentTime=incident.time.getTime();
if(incidentTime>intervalEndTime){
break;
}
if(incidentTime>=intervalStartTime){
filteredIncidents.push(incident);
}else{
finalIncidentBeforeInterval=incident;
}
}

return{
filteredIncidents:filteredIncidents,
finalIncidentBeforeInterval:finalIncidentBeforeInterval};

};StatisticsPanelHelpers.

getDayDifference=function getDayDifference(laterUnixTime,earlierUnixTime){
return Math.floor((laterUnixTime-earlierUnixTime)/DayInMilliseconds);
};StatisticsPanelHelpers.

getUtcReferenceStartOfDayFor=function getUtcReferenceStartOfDayFor(time,timezone){
return CalendarDay.calendarDayFor({time:time,timezone:timezone}).startOfDayInTimezone('Etc/Utc');
};StatisticsPanelHelpers.

getUtcReferenceAxisDomainFor=function getUtcReferenceAxisDomainFor(interval,timezone){
_.ensureInstanceOf(TimeInterval,interval);
_.ensureInstanceOf('string',timezone);

return[interval.start,interval.end].map(function(t){return StatisticsPanelHelpers.getUtcReferenceStartOfDayFor(t,timezone)});
};StatisticsPanelHelpers.

getUtcReferenceStartOfMonthFor=function getUtcReferenceStartOfMonthFor(time,timezone){
_.ensureInstanceOf(Date,time);
_.ensureInstanceOf('string',timezone);

const yearAndMonth=zonedMoment(time,timezone).format(YEAR_MONTH_FORMAT);
return moment.utc(yearAndMonth,YEAR_MONTH_FORMAT).toDate();
};StatisticsPanelHelpers.

getSubComponentDimensionsFrom=function getSubComponentDimensionsFrom(){let{height=MinimumStatisticsPanelDimensions.height,width=MinimumStatisticsPanelDimensions.width}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};
const availableHeight=height-StatisticsPanelWrapperBorderThickness*2-StatisticsPanelHeaderBottomBorderThickness;
const availableWidth=width-StatisticsPanelWrapperBorderThickness*2-StatisticsPanelBodyVerticalDividingBorderThickness;

const panelBodyHeight=availableHeight-StatisticsPanelHeaderHeight;

return{
left:{
height:panelBodyHeight,
width:panelBodyHeight},

right:{
height:panelBodyHeight,
width:availableWidth-panelBodyHeight}};


};StatisticsPanelHelpers.

getPathStartTimeForDaysSinceGraph=function getPathStartTimeForDaysSinceGraph(lastIncidentTimeBeforeInterval,startOfDayForLastPurgedIncident,boundsStart,creationTime){
if([lastIncidentTimeBeforeInterval,startOfDayForLastPurgedIncident,boundsStart,creationTime].every(function(t){return!_.exists(t)})){
return null;
}

if(_.exists(lastIncidentTimeBeforeInterval)||_.exists(startOfDayForLastPurgedIncident)){
return _([lastIncidentTimeBeforeInterval,startOfDayForLastPurgedIncident]).compact().maxBy(function(t){return t.getTime()});
}

return _([boundsStart,creationTime]).compact().minBy(function(t){return t.getTime()});
};StatisticsPanelHelpers.

getDaysSinceLastIncidentGraphViewData=function getDaysSinceLastIncidentGraphViewData(dataStartTime,incidents,timezone,interval){
_.ensureInstanceOf(Array,incidents);
_.ensureInstanceOf('string',timezone);
_.ensureInstanceOf(TimeInterval,interval);

const graphXAxisDomain=StatisticsPanelHelpers.getUtcReferenceAxisDomainFor(interval,timezone);

if(!_.exists(dataStartTime)){
return{
graphViewData:[],
daysSinceMostRecentIncident:null,
graphYAxisDomain:[0,1],
graphXAxisDomain:graphXAxisDomain};

}

_.ensureInstanceOf(Date,dataStartTime);

const getUnixDayStartFor=function(time){return CalendarDay.calendarDayFor({time:time,timezone:timezone}).valueOf()};
const reversedUTCUnixTimes=_([{time:dataStartTime}].concat(_toConsumableArray(incidents))).
map(function(_ref){let{time:time}=_ref;return getUnixDayStartFor(time)}).
sortedUniqBy().
concat(getUnixDayStartFor(interval.end)).
reverse().
value();

const numPoints=reversedUTCUnixTimes.length;
const reverseXYPairsPerTime=Array(numPoints);

let previouslySeenUnixTime=reversedUTCUnixTimes[0];
let largestDayDifference=0;
for(let i=1;i<numPoints;i++){
const currentUnixTime=reversedUTCUnixTimes[i];

let dayDifference=StatisticsPanelHelpers.getDayDifference(previouslySeenUnixTime,currentUnixTime);

if(i!==1){



dayDifference--;
}

reverseXYPairsPerTime[i-1]=[
[reversedUTCUnixTimes[i-1],0],
[reversedUTCUnixTimes[i-1],dayDifference]];


if(dayDifference>largestDayDifference){
largestDayDifference=dayDifference;
}

previouslySeenUnixTime=currentUnixTime;
}

reverseXYPairsPerTime[numPoints-1]=[
[reversedUTCUnixTimes[numPoints-1],0]];


const flatReverseXYPairsPerIncident=_.flatten(reverseXYPairsPerTime);
return{
graphViewData:flatReverseXYPairsPerIncident,
daysSinceMostRecentIncident:flatReverseXYPairsPerIncident[1][1],
graphYAxisDomain:[0,largestDayDifference],
graphXAxisDomain:graphXAxisDomain};

};_createClass(StatisticsPanelHelpers,null,[{key:'MinimumStatisticsPanelDimensions',get:function()

{
return MinimumStatisticsPanelDimensions;
}},{key:'DayInMilliseconds',get:function()

{
return DayInMilliseconds;
}},{key:'DefaultTransitionDuration',get:function()

{
return DefaultTransitionDuration;
}},{key:'TotalMonthsToDisplayInGraph',get:function()

{
return TotalMonthsToDisplayInGraph;
}}]);return StatisticsPanelHelpers}();


module.exports=StatisticsPanelHelpers;
//# sourceMappingURL=statisticsPanelHelpers.js.map
